module.exports = __webpack_public_path__ + "img/cake.f8d3c436.svg";